// A queued push may arrive after focus or explicit background suppression changes.
// Always require this browser's exact account binding and selected chat.
export function shouldSuppressOpenChatPush(payload: Record<string, unknown>, current: {
  attended: boolean; suppressWhileOpen?: boolean; conversationId: string | null; binding: Record<string, unknown> | null;
}): boolean {
  return payload.type === 'chat.message' && (current.attended || current.suppressWhileOpen === true)
    && typeof payload.conversation_id === 'string' && payload.conversation_id === current.conversationId
    && typeof payload.binding_id === 'string' && typeof payload.binding_version === 'number'
    && current.binding?.binding_id === payload.binding_id && current.binding?.binding_version === payload.binding_version;
}
